import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import {
    BusinessServiceFilter,
    HypervisorFilter,
    ServerTypeFilter,
    SiteFilter,
    StatusFilter,
    TimeRangeFilter,
} from '../../filters';
import { ServerListPanel } from '../../panels';

export const pageId = 'servers';

export default function ServersPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Servers`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <BusinessServiceFilter />
                    <HypervisorFilter />
                    <ServerTypeFilter />
                    <SiteFilter />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <ServerListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
